import { render, staticRenderFns } from "./BaseBackLink.vue?vue&type=template&id=21c66b9c&scoped=true&"
import script from "./BaseBackLink.vue?vue&type=script&lang=js&"
export * from "./BaseBackLink.vue?vue&type=script&lang=js&"
import style0 from "./BaseBackLink.vue?vue&type=style&index=0&id=21c66b9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c66b9c",
  null
  
)

export default component.exports